import { render, staticRenderFns } from "./AlertListPage.vue?vue&type=template&id=31bcfc3b&"
import script from "./AlertListPage.vue?vue&type=script&lang=ts&"
export * from "./AlertListPage.vue?vue&type=script&lang=ts&"
import style0 from "./AlertListPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports